import { FieldDesc, IncludeDesc } from '90.quickConnect.Models/models';
import { FieldType, Mandatory } from '90.quickConnect.Models/enums';

export const isMandatoryItems = (fieldDesc: FieldDesc): boolean => {
  // visible peut être un objet (règle de visibilité) : la visibilité réelle est alors portée par isVisible
  const isSelfMandatory =
    fieldDesc.mandatory === Mandatory.Required && fieldDesc.visible !== false && fieldDesc.isVisible === true;

  if (isSelfMandatory) return true;

  if (fieldDesc.items?.length) {
    return fieldDesc.items.some((i) => isMandatoryItems(i));
  }

  return false;
};

export const getMandatoryInTemplate = (
  { items, mandatory }: FieldDesc,
  templateBodies: Record<string, string>,
): Mandatory | undefined => {
  const allItemsInFieldToCheck: FieldDesc[] = items.reduce((acc: FieldDesc[], item: FieldDesc) => {
    const { fieldType } = item;
    if (fieldType !== FieldType.Include) return acc;

    const { modelId } = item as IncludeDesc;

    const tplParsed = JSON.parse(templateBodies[modelId]) as FieldDesc[];

    return [...acc, ...tplParsed];
  }, [] as FieldDesc[]);

  return allItemsInFieldToCheck.some(isMandatoryItems) ? Mandatory.Required : mandatory;
};
